// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24tze","option":"styles_option__2OjsO","selected":"styles_selected__BU-rf"};